import { Hero } from './hero/Hero';
import { PickTrip } from './pickTrip/PickTrip';

export const Home = () => (
    <div className="home">
        <Hero/>
        <PickTrip/>
    </div>
);
